import { Injectable } from '@angular/core';
import { BrowserListenerEvent } from './browser-communication.models';

@Injectable({
    providedIn: 'root'
})
export class BrowserCommunicationService {
    postMessage(message: any) {
        this.commChannel.postMessage(message);
    }

    private commChannel = new BroadcastChannel('benelynk');

    constructor() {
    }

    addListener(callBack: EventListenerOrEventListenerObject) {
        this.commChannel.addEventListener('message', callBack);
    }
}
